// Backend-shaped fixtures: user tracker IDs are present only for tracked entities.
const uuid = value => `00000000-0000-4000-8000-${String(value).padStart(12, '0')}`
const companies = [
  ['Apple', 'Technology', 'apple', 'apple.com'],
  ['JPMorgan Chase', 'Financial Services', 'jpmorgan-chase', 'jpmorganchase.com'],
  ['Pfizer', 'Pharmaceuticals', 'pfizer', 'pfizer.com'],
  ['Microsoft', 'Technology', 'microsoft', 'microsoft.com'],
  ['Salesforce', 'Software', 'salesforce', 'salesforce.com'],
  ['NVIDIA', 'Semiconductors', 'nvidia', 'nvidia.com'],
  ['Visa', 'Financial Services', 'visa', 'visa.com'],
  ['Adobe', 'Software', 'adobe', 'adobe.com'],
  ['Amazon', 'Retail', 'amazon', 'amazon.com'],
  ['Cisco', 'Networking', 'cisco', 'cisco.com'],
  ['Oracle', 'Software', 'oracle', 'oracle.com'],
  ['IBM', 'Technology', 'ibm', 'ibm.com']
]

export const TRACKER_WIDGETS_MOCKS = [
  {
    type: 'tracker_companies',
    title: 'Tracker candidates',
    entities: companies.map(([name, industry, linkedin_id, domain], index) => ({
      name,
      industries: [industry],
      linkedin_id,
      linkedin_url: `https://www.linkedin.com/company/${linkedin_id}`,
      website_url: `https://www.${domain}`,
      shared_company_id: uuid(index + 1),
      ...(index === 1 ? {user_company_id: uuid(101)} : {})
    }))
  },
  {
    type: 'tracker_contacts',
    title: 'Contact tracker candidates',
    entities: [
      {name: 'Alex Morgan', position: 'Chief Technology Officer', company_name: 'Apple', company_linkedin_id: 'apple', shared_company_id: uuid(1), linkedin_id: 'alex-morgan-demo', linkedin_url: 'https://www.linkedin.com/in/alex-morgan-demo', shared_contact_id: uuid(201)},
      {name: 'Jamie Chen', position: 'VP of Engineering', company_name: 'Microsoft', company_linkedin_id: 'microsoft', shared_company_id: uuid(4), linkedin_id: 'jamie-chen-demo', shared_contact_id: uuid(202), user_contact_id: uuid(301)},
      {name: 'Taylor Smith', linkedin_id: 'taylor-smith-demo'},
    ]
  },
  {
    type: 'tracker_topics',
    title: 'Topic tracker candidates',
    entities: [
      {name: 'Artificial intelligence', shared_topic_id: uuid(401)},
      {name: 'Cybersecurity', shared_topic_id: uuid(402), user_topic_id: uuid(501)},
      {name: 'Sustainable supply chains'},
    ]
  }
]

export const TRACKER_MOCK_HISTORY = TRACKER_WIDGETS_MOCKS.flatMap(widget => [
  {
    type: 'user',
    data: {text: `Add ${widget.type.replace('tracker_', '')} to the tracker from the uploaded file`, title: `Add ${widget.type.replace('tracker_', '')} to the tracker from the uploaded file`}
  },
  {
    type: 'assistant',
    data: {
      text: `We extracted ${widget.entities.length} ${widget.type.replace('tracker_', '')} from the uploaded file. One was already tracked by you.\n\n[Tracker candidates](widgets://0)`,
      widgets: [widget]
    }
  }
])
